
import { defineComponent } from "vue";

import PackageVolumeTypeCatalogue from "@/components/catalogues/PackageVolumeTypeCatalogue/PackageVolumeTypeCatalogue.vue";

export default defineComponent({
  components: { PackageVolumeTypeCatalogue },
  props: {},
  methods: {},
  data() {
    return {};
  },
});
